export default "__VITE_ASSET__BTfTwQ8C__"